<script lang="ts">
  import ContentContainer from "../components/content-box-system/ContentContainer.svelte";
  import ContentSection from "../components/content-box-system/ContentSection.svelte";
  import { loadJSON } from "../loader";

  const data =
    loadJSON<
      { name: string; author: string; licenseType: string; link: string }[]
    >("/oss-credits.json");
</script>

<main>
  <ContentContainer classNames="pure-g">
    <div class="pure-u-1-1">
      <ContentSection title="Open Source">
        <h3>Open Source libraries used</h3>
        <hr />
        <p>
          This website is built with freely available Open Source tools and
          libraries. Here's what we depend upon:
        </p>
        {#await data}
          <div class="spinner" />
        {:then data}
          <table class="pure-table pure-table-horizontal">
            <thead>
              <tr>
                <th>Name</th>
                <th>Author</th>
                <th>License</th>
                <th>Link</th>
              </tr>
            </thead>
            <tbody>
              {#each data as dependency}
                <tr>
                  <td>{dependency.name}</td>
                  <td>{dependency.author}</td>
                  <td>{dependency.licenseType}</td>
                  <td>{dependency.link}</td>
                </tr>
              {/each}
            </tbody>
          </table>
        {/await}
      </ContentSection>
    </div>
  </ContentContainer>
</main>

<style></style>
